import { Component, input, ChangeDetectionStrategy, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { HugeiconsIconComponent } from '@hugeicons/angular';

@Component({
  selector: 'app-sidebar-item',
  standalone: true,
  imports: [CommonModule, RouterLink, RouterLinkActive, HugeiconsIconComponent],
  templateUrl: './sidebar-item.html',
  styleUrl: './sidebar-item.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidebarItem {
  label = input.required<string>();
  route = input<string | null>(null);
  // Existing string-based SVG icon support
  icon = input<string | null>(null);
  // Hugeicons support (e.g. DashboardSquare03Icon)
  hugeIcon = input<any | null>(null);
  active = input<boolean>(false);
  collapsed = input<boolean>(false);
}

